<template>
    <div >
        <Spin v-if="tkLoading" size='large'></Spin>
        <div v-else class="bank">
            <Row :gutter="60" style="width:100%" v-if="bankList.length">
            <i-col  :md="12" :lg="8" :xl="8" :xxl="6" :style="{ marginBottom: '30px' }" v-for="(item,i) in bankList" :key="i">
                <div class="qb-item">
                    <div class="left-top"><Icon type="md-bookmarks" color="#FF9D00" size="20"/>题库{{util.convertToChinese(i+1)}}</div>
                    <div class="title" :title="item.title">{{item.title}}</div>
                    <Button class="btnActive" type="primary" shape="circle" size="large" @click="enterBankPractise(item)">进入练习</Button>
                </div>
            </i-col>
            </Row>
            <nullPage v-else style="width:100%">
                <div slot="tipsText">暂无题库信息，点击右上角去激活吧！</div>
            </nullPage>
        </div>
        <!-- 当前知识点信息弹框 -->
        <Modal v-model="infoModal" class='infoModal' width="460" @on-cancel="handleCancel">
            <div class="title">题库练习</div>
            <div class="con">
                <div class="top">
                    <div>题库：<span>{{currQuestionInfo.title}}</span></div>
                    <div v-if="currQuestionInfo.totalCount>0">总题目数：<span>{{currQuestionInfo.totalCount}}道</span></div>
                    <div v-if="currQuestionInfo.multipleChoiceCount>0">单选题数量：<span>{{currQuestionInfo.multipleChoiceCount}}道</span></div>
                    <div v-if="currQuestionInfo.multipleSelectionCount>0">多选题数量：<span>{{currQuestionInfo.multipleSelectionCount}}道</span></div>
                    <div v-if="currQuestionInfo.trueFalseCount>0">判断题数量：<span>{{currQuestionInfo.trueFalseCount}}道</span></div>
                    <div v-if="currQuestionInfo.fillsCount>0">填空题数量：<span>{{currQuestionInfo.fillsCount}}道</span></div>
                    <!-- <div v-if="currQuestionInfo.essayCount>0">主观题数量：<span>{{currQuestionInfo.essayCount}}道</span></div> -->
                    <div v-if="currQuestionInfo.programmingCount>0">编程题数量：<span>{{currQuestionInfo.programmingCount}}道</span></div>
                </div>
                <div class="choose-num">
                    <Form ref="formData" :model="formData" :label-width="80" :rules="formDataValidate">
                        <FormItem prop="multipleChoiceCount" label="单选题：" v-if="currQuestionInfo.multipleChoiceCount>0">
                            <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.multipleChoiceCount +'道'">
                                <InputNumber v-model="formData.multipleChoiceCount" type="number" :max="currQuestionInfo.multipleChoiceCount" :min="0" autocomplete="off"/>
                            </Tooltip>
                        </FormItem>
                        <FormItem prop="multipleSelectionCount" label="多选题：" v-if="currQuestionInfo.multipleSelectionCount>0">
                            <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.multipleSelectionCount +'道'">
                                <InputNumber v-model="formData.multipleSelectionCount" type="number" :max="currQuestionInfo.multipleSelectionCount" :min="0" autocomplete="off"/>
                            </Tooltip>
                        </FormItem>
                        <FormItem prop="trueFalseCount" label="判断题：" v-if="currQuestionInfo.trueFalseCount>0">
                            <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.trueFalseCount +'道'">
                                <InputNumber v-model="formData.trueFalseCount" type="number" :max="currQuestionInfo.trueFalseCount" :min="0" autocomplete="off"/>
                            </Tooltip>
                        </FormItem>
                        <FormItem prop="fillsCount" label="填空题：" v-if="currQuestionInfo.fillsCount>0">
                            <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.fillsCount +'道'">
                                <InputNumber v-model="formData.fillsCount" type="number" :max="currQuestionInfo.fillsCount" :min="0" autocomplete="off"/>
                            </Tooltip>
                        </FormItem>
                        <!-- <FormItem prop="essayCount" label="主观题：" v-if="currQuestionInfo.essayCount>0">
                            <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.essayCount +'道'">
                                <InputNumber v-model="formData.essayCount" type="number" :max="currQuestionInfo.essayCount" :min="0" autocomplete="off"/>
                            </Tooltip>
                        </FormItem> -->
                        <FormItem prop="programmingCount" label="编程题：" v-if="currQuestionInfo.programmingCount>0">
                            <Tooltip :content="'输入题数不得大于'+ currQuestionInfo.programmingCount +'道'">
                                <InputNumber v-model="formData.programmingCount" type="number" :max="currQuestionInfo.programmingCount" :min="0" autocomplete="off"/>
                            </Tooltip>
                        </FormItem>
                    </Form>
                    <div class="tip">提示：输入自己想要完成的类型数目进行答题</div>
                </div>
                <Button size="large" @click="toPractiseKnowledge">开始练习</Button>
            </div>
            
        </Modal>
    </div>
</template>
<script>
import nullPage from './components/nullPage.vue'
import util from '@/libs/util'
export default {
    components:{ nullPage },
    props:{
        bankList:{
            type: Array,
            default:null
        },
        tkLoading:{
            type: Boolean,
            default:false
        }
    },
    created(){
        this.userInfo = util.localGet('userInfo')
    },
    data(){
        return{
            userInfo: {},
            util: util,
            infoModal: false,
            currQuestionInfo: {},
            currKnowledgeId: '',
            formData: {
                multipleChoiceCount: 0,
                multipleSelectionCount: 0,
                trueFalseCount: 0,
                fillsCount: 0,
                essayCount: 0,
                programmingCount: 0,
            },
            formDataValidate: {
                multipleChoiceCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
                multipleSelectionCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
                trueFalseCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
                fillsCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
                essayCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
                programmingCount: [{required: true, type: "number", message: "必填选项",trigger: "blur"},],
            },
        }
    },
    methods:{
        enterBankPractise(item){
            this.infoModal = true
            this.currQuestionInfo = item
            this.currKnowledgeId = item.id
            
        },
        toPractiseKnowledge(){
            this.$refs.formData.validate(async valid => {
                if(valid){
                    let params = {
                        userId: this.userInfo.id,
                        userName: this.userInfo.username,
                        batchType: 1,
                        batchTypeItemId: this.currKnowledgeId,
                        multipleChoiceCount: this.formData.multipleChoiceCount,
                        multipleSelectionCount: this.formData.multipleSelectionCount,
                        trueFalseCount: this.formData.trueFalseCount,
                        fillsCount: this.formData.fillsCount,
                        essayCount: this.formData.essayCount,
                        programmingCount: this.formData.programmingCount,
                    }
                    if(!params.multipleChoiceCount && !params.multipleSelectionCount && !params.trueFalseCount && !params.fillsCount && !params.programmingCount ){
                        // 选项均为0
                        this.$Message.info('请输入您要练习的类型数量')
                        return false
                    }
                    util.md5Encryption(params)
                    const res = await this.postTKRequest('/v1/getPracticeBatchInfo',params,true)
                    if(res.success){
                        util.localSet('bankQuestionIds',{ batchId: res.result.batchId,questionIds: JSON.stringify(res.result.questionIds) } )
                        // this.childTimeInfo = {}
                        this.$router.push({
                            name: 'testStore',
                        })
                    }
                }
            })
        },
        handleCancel(){
            this.infoModal = false
            this.formData= {
                multipleChoiceCount: 0,
                multipleSelectionCount: 0,
                trueFalseCount: 0,
                fillsCount: 0,
                essayCount: 0,
                programmingCount: 0,
            }
        }
    }
}
</script>
<style lang="less" scoped>
.infoModal{
    /deep/ .ivu-modal-content{
        background-color: transparent;
    }
    /deep/ .ivu-modal-body{
        padding: 0;
    }
    /deep/ .ivu-modal-footer{
        display: none;
    }
    .title{
        position: relative;
        z-index: 1;
        width: 100%;
        height: 130px;
        line-height: 130px;
        text-align: center;
        color: #fff;
        font-size: 30px;
        background: url('../../assets/modalTop.png') no-repeat;
        background-size: 100% 100%;
    }
    .con{
        margin-top: -10px;
        width: 100%;
        padding: 30px 20px 20px;
        background-color: #fff;
        border-radius: 0 0 10px 10px ;
        .top{
            display: inline-flex;
            flex-wrap: wrap;
            padding-bottom: 20px;
            margin-bottom: 20px;
            border-bottom: 1px dashed #ccc;
            div{
                width: 40%;
                height: 30px;
                line-height: 30px;
                span{
                    color: #ffa200;
                }
            }
            div:first-child{
                width: 100%;
            }
            div:nth-child(2){
                width: 100%;
            }
        }
        .choose-num{
            .ivu-form{
                display: inline-flex;
                flex-wrap: wrap;
                .ivu-form-item:nth-child(2n){
                    margin-left: 30px;
                }
            }
            .tip{
                background: #F0F0F0;
                color: #999;
                padding: 5px 10px;
                border-radius: 4px;
                width: 72%;
                margin-bottom: 40px;
            }
        }
        /deep/ .ivu-btn{
            width: 100%;
            background: #ffa200;
            color: #fff;
        }
    }
}
.bank{
    display: flex;
    flex-wrap: wrap;
}
.qb-item{
    position: relative;
    display: flex;
    flex-direction: column;
    height: 255px;
    background: url('../../assets/item.png') no-repeat;
    background-size: 100% 100%;
    transition: all .5s;
    .left-top{
        // position: absolute;
        margin-left: 15px;
        margin-top: 15px;
        font-size: 16px;
        /deep/ .ivu-icon{
            margin-right: 6px;
        }

    }
    .title{
        position: absolute;
        top: 120px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
        padding: 0 20px;
        overflow: hidden;
        transition: all .5s;
    }
    /deep/ .ivu-btn{
        position: absolute;
        top: 180px;
        left: 50%;
        font-size: 14px;
        padding: 0 20px;
        outline: none;
        border-color: #ff9d00;
        transform: translateX(-50%);
        background-color: #fff;
        color: #ff9d00;
        transition: all .5s;
    }
}
.qb-item:hover{
    background: url('../../assets/itemActive.png') no-repeat;
    background-size: 100% 100%;
    .left-top,.title{
        color: #fff;
        /deep/ .ivu-icon{
            color: #fff!important;
        }
    }
    /deep/ .ivu-btn{
        background-color: #fff;
        color: #FF9D00;
        border-color: #fff;
    }
}
/deep/ .ivu-spin{
    display: flex;
    width: 100%;
    height: 400px;
    justify-content: center;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/practise/questionBank.vue